(function () {
  // When the shopper changes the native Shopify "Profile" option, force the
  // native "Finish" option back to a "Please select" placeholder and disable
  // Add-to-Cart until they actively pick a Finish for the new Profile.
  //
  // Profile/Finish are native Shopify variant options rendered by
  // snippets/variant-picker.liquid (dropdown style → custom-select web component).
  // Colour is handled separately by Easify.

  var PROFILE = 'Profile';
  var FINISH = 'Finish';
  var PLACEHOLDER = 'Please select';

  // Set when the user changes Profile; consumed on the next picker swap.
  var pendingFinishReset = false;

  function disableAddToCart() {
    // Theme gates submit on aria-disabled (see ProductForm.onSubmitHandler).
    var btn = document.querySelector(
      'product-form [type="submit"], form[action*="/cart/add"] [type="submit"]'
    );
    if (btn) btn.setAttribute('aria-disabled', 'true');
  }

  function clearVariantId() {
    document
      .querySelectorAll('product-form form input[name="id"], form[action*="/cart/add"] input[name="id"]')
      .forEach(function (input) {
        input.value = '';
      });
  }

  // scope = the freshly-inserted <variant-picker> node.
  function resetFinish(scope) {
    var select = scope.querySelector('select[name="options[' + FINISH + ']"]');
    if (!select) return;

    // Move the `selected` attribute off the option Shopify auto-resolved.
    var resolved = select.querySelector('option[selected]');
    if (resolved) resolved.removeAttribute('selected');

    // Insert (or reuse) a placeholder option and select it. We must keep exactly
    // one option carrying the `selected` attribute, otherwise
    // VariantPicker.updateSelectionMetadata() crashes on the next Finish change
    // (it does options.find(o => o.getAttribute('selected')).removeAttribute(...)).
    var placeholder = select.querySelector('option[data-fliplab-placeholder]');
    if (!placeholder) {
      placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = PLACEHOLDER;
      placeholder.setAttribute('data-fliplab-placeholder', '');
      select.insertBefore(placeholder, select.firstChild);
    }
    placeholder.setAttribute('selected', 'selected');
    select.value = '';

    // Sync the visible custom-select button label.
    var wrap = select.closest('.variant-picker__input--dropdown');
    if (wrap) {
      var button = wrap.querySelector('.custom-select__button');
      if (button) button.textContent = PLACEHOLDER;
    }

    clearVariantId();
    disableAddToCart();
  }

  // Capture phase so we record the Profile change before variant-picker's own
  // handler fires the section re-fetch. Easify only ever fires synthetic changes
  // on Colour, so a Profile change here is always user-driven.
  document.addEventListener(
    'change',
    function (e) {
      var t = e.target;
      if (t && t.tagName === 'SELECT' && t.getAttribute('name') === 'options[' + PROFILE + ']') {
        pendingFinishReset = true;
      }
    },
    true
  );

  // Primavera's viewTransition inserts a brand-new <variant-picker> sibling on
  // every option change — and it does so BEFORE product-page.js bails out on an
  // unresolved (null) variant. So observing the swap fires reliably on a Profile
  // change even when the old Finish/Colour combo has no valid variant yet, unlike
  // the variant:change event.
  function watchVariantPicker() {
    var vp = document.querySelector('variant-picker');
    if (!vp || !vp.parentNode) return;

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].localName === 'variant-picker' && pendingFinishReset) {
            pendingFinishReset = false;
            resetFinish(added[j]);
          }
        }
      }
    }).observe(vp.parentNode, { childList: true });
  }

  window.addEventListener('load', function () {
    setTimeout(watchVariantPicker, 300);
  });
})();
